module.exports = __webpack_public_path__ + "files/ca54e5b1cacb878238eaa5150857a4b6.svg";